import { makeDayKey } from '../monthGrid'

/** The days a story runs for. Either end can be open. */
export type CalendarDateRange = Readonly<{
  /** ISO 8601, day precision or a full instant. */
  start?: string | null
  end?: string | null
}>

/** What the calendar says when a day is outside the story it is scoped to. */
export const OUTSIDE_STORY_RANGE = 'Outside of Story Date Range'

const dayOf = (value: string | null | undefined): string | undefined =>
  value === null || value === undefined ? undefined : value.slice(0, 10)

/**
 * Whether something can be made on this day.
 *
 * Inside a story, only the days the story runs for can hold anything new — the
 * rule the legacy month view enforced, kept because the story would otherwise
 * gain a moment it does not cover. A story with no dates has no such limit.
 */
export const isWithinDateRange = (
  date: Date,
  range?: CalendarDateRange
): boolean => {
  if (range === undefined) return true

  const day = makeDayKey(date)
  const start = dayOf(range.start)
  const end = dayOf(range.end)

  if (start !== undefined && day < start) return false
  if (end !== undefined && day > end) return false
  return true
}
